export default __webpack_public_path__ + "static/media/style10.c6ea2356.svg";